var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./address-card-solid.svg": "./src/icons/svg/address-card-solid.svg",
	"./at-solid.svg": "./src/icons/svg/at-solid.svg",
	"./balance-scale-solid.svg": "./src/icons/svg/balance-scale-solid.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./building-solid.svg": "./src/icons/svg/building-solid.svg",
	"./calendar-check-regular.svg": "./src/icons/svg/calendar-check-regular.svg",
	"./calendar-day-solid.svg": "./src/icons/svg/calendar-day-solid.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./circle-check.svg": "./src/icons/svg/circle-check.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./clock-regular.svg": "./src/icons/svg/clock-regular.svg",
	"./cogs-solid.svg": "./src/icons/svg/cogs-solid.svg",
	"./comments-solid.svg": "./src/icons/svg/comments-solid.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./cvt.svg": "./src/icons/svg/cvt.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./envelope-open-regular.svg": "./src/icons/svg/envelope-open-regular.svg",
	"./envelope-solid.svg": "./src/icons/svg/envelope-solid.svg",
	"./euro-sign-solid.svg": "./src/icons/svg/euro-sign-solid.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exclamation-circle-solid.svg": "./src/icons/svg/exclamation-circle-solid.svg",
	"./exclamation-triangle-solid.svg": "./src/icons/svg/exclamation-triangle-solid.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./external-link-alt-solid.svg": "./src/icons/svg/external-link-alt-solid.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./file-code-solid.svg": "./src/icons/svg/file-code-solid.svg",
	"./file-invoice-solid.svg": "./src/icons/svg/file-invoice-solid.svg",
	"./file-upload-solid.svg": "./src/icons/svg/file-upload-solid.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./headset-solid.svg": "./src/icons/svg/headset-solid.svg",
	"./hourglass-end-solid.svg": "./src/icons/svg/hourglass-end-solid.svg",
	"./hourglass-start-solid.svg": "./src/icons/svg/hourglass-start-solid.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./id-badge-solid.svg": "./src/icons/svg/id-badge-solid.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./launch.svg": "./src/icons/svg/launch.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./mouse-pointer-solid.svg": "./src/icons/svg/mouse-pointer-solid.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./paper-plane-regular.svg": "./src/icons/svg/paper-plane-regular.svg",
	"./paperclip-solid.svg": "./src/icons/svg/paperclip-solid.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./pencil-alt-solid.svg": "./src/icons/svg/pencil-alt-solid.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./phone-solid.svg": "./src/icons/svg/phone-solid.svg",
	"./plus-circle-solid.svg": "./src/icons/svg/plus-circle-solid.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./rocket-solid.svg": "./src/icons/svg/rocket-solid.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./shapes-solid.svg": "./src/icons/svg/shapes-solid.svg",
	"./shield-alt-solid.svg": "./src/icons/svg/shield-alt-solid.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./sms-solid.svg": "./src/icons/svg/sms-solid.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./store-solid.svg": "./src/icons/svg/store-solid.svg",
	"./sync-alt-solid.svg": "./src/icons/svg/sync-alt-solid.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./tasks-solid.svg": "./src/icons/svg/tasks-solid.svg",
	"./temperature-high-solid.svg": "./src/icons/svg/temperature-high-solid.svg",
	"./temperature-low-solid.svg": "./src/icons/svg/temperature-low-solid.svg",
	"./th-list-solid.svg": "./src/icons/svg/th-list-solid.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./times-circle-solid.svg": "./src/icons/svg/times-circle-solid.svg",
	"./transit.svg": "./src/icons/svg/transit.svg",
	"./trash-alt-solid.svg": "./src/icons/svg/trash-alt-solid.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./undo-solid.svg": "./src/icons/svg/undo-solid.svg",
	"./up-right-from-square.svg": "./src/icons/svg/up-right-from-square.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";